Nightmare = {
    replay: null,    // 用以传入reply数据

    // 用以打印Nightmare相关的信息以与其通信
    log(...args) {
        cc.log.apply(this, ["selenium:" + args[0]])
        args.unshift('Nightmare:')
        cc.log.apply(this, args)
    }
}
